/**
 * Used keys for local storage
 *
 * After clearing the key, please add to the list below,
 * to keep the history of used keys:
 * 1. ...
 * 2. ...
 *
 */

export enum LocalStorageKeys {
  FEATURED_APPLICANTS_KEYBOARD_SHORTCUTS_NOTICE_SEEN_COUNT = 'featuredApplicantsKeyboardShortcutsNoticeSeenCount',
  KEYBOARD_SHORTCUTS_NOTICE_SEEN_COUNT = 'keyboardShortcutsNoticeSeenCount',
  SAVED_CHAT_MESSAGES = 'savedChatMessages',
  TOKEN_STORAGE_KEY = '_uatoken',
  VT_RECENT_SEARCHES = 'vt-recent-searches',
}
